// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout[data-v-6c0682a6] {\n  padding-left: 70px;\n  height: 100%;\n}\n.workspace[data-v-6c0682a6] {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n}\n.content[data-v-6c0682a6] {\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
